// src/components/rewards/ChestArt.js
//
// A treasure chest in three tiers — wood, silver, gold — with a lid that
// can swing open. Pure SVG; the animation classes live in rewards.css.

import React from "react";

const TIERS = {
  wood: { body: "#b5651d", lid: "#c97a2e", band: "#6b4a2b", lock: "#d8b25a", glow: "#ffe9a8" },
  silver: { body: "#8fa3bf", lid: "#a9bcd6", band: "#4a5b75", lock: "#e6eef9", glow: "#dff0ff" },
  gold: { body: "#e7a91a", lid: "#f6c936", band: "#9c6a00", lock: "#fff1a8", glow: "#fff6b8" },
};

const INK = "#2a2130";

const ChestArt = ({ tier = "wood", open = false, className = "" }) => {
  const T = TIERS[tier] || TIERS.wood;
  return (
    <svg viewBox="0 0 120 110" className={`sbl-chest-art is-${tier} ${open ? "is-open" : ""} ${className}`} aria-hidden="true">
      {open && (
        <g className="sbl-chest-rays">
          {Array.from({ length: 12 }, (_, i) => (
            <path key={i} d="M60 52 L55 -10 L65 -10 Z" fill={T.glow} opacity="0.7" transform={`rotate(${i * 30} 60 52)`} />
          ))}
          <circle cx="60" cy="52" r="26" fill={T.glow} opacity="0.9" />
        </g>
      )}
      {/* body */}
      <rect x="14" y="52" width="92" height="48" rx="7" fill={T.body} stroke={INK} strokeWidth="4" />
      <rect x="14" y="66" width="92" height="7" fill={T.band} stroke={INK} strokeWidth="2" />
      <rect x="24" y="52" width="8" height="48" fill={T.band} opacity="0.85" />
      <rect x="88" y="52" width="8" height="48" fill={T.band} opacity="0.85" />
      {tier === "gold" &&
        [[40, 88, "#ff4d6d"], [60, 90, "#4fd1ff"], [80, 88, "#7dff9a"]].map(([x, y, c]) => (
          <path key={x} d={`M${x} ${y - 4} l4 4 -4 4 -4 -4 Z`} fill={c} stroke={INK} strokeWidth="1.2" />
        ))}
      {open && (
        <g>
          <ellipse cx="60" cy="54" rx="40" ry="8" fill="#3b2412" />
          <circle cx="44" cy="50" r="7" fill="#ffd23f" stroke="#b07a00" strokeWidth="2" />
          <circle cx="60" cy="47" r="7" fill="#ffd23f" stroke="#b07a00" strokeWidth="2" />
          <circle cx="75" cy="50" r="7" fill="#ffd23f" stroke="#b07a00" strokeWidth="2" />
        </g>
      )}
      {/* lid */}
      <g className="sbl-chest-lid">
        <path d="M14 54 Q14 22 60 20 Q106 22 106 54 Z" fill={T.lid} stroke={INK} strokeWidth="4" strokeLinejoin="round" />
        <path d="M24 52 Q25 28 32 25 L32 52 Z M96 52 Q95 28 88 25 L88 52 Z" fill={T.band} opacity="0.85" />
        <path d="M30 32 Q60 22 90 32" stroke="#fff" strokeWidth="3" fill="none" opacity="0.45" strokeLinecap="round" />
      </g>
      {/* lock */}
      {!open && (
        <g>
          <rect x="51" y="48" width="18" height="20" rx="4" fill={T.lock} stroke={INK} strokeWidth="3" />
          <circle cx="60" cy="56" r="2.6" fill={INK} />
          <path d="M60 57 L60 62" stroke={INK} strokeWidth="2.4" strokeLinecap="round" />
        </g>
      )}
    </svg>
  );
};

export default ChestArt;
